import React, { Component } from 'react';

import './../../../../scss/App.scss';

class BonusInstructionsOverlay extends Component {
	constructor(props){
		super(props);

		this.transitionIn = new window.TimelineMax({onComplete : this.handleTransitionComplete,
									onCompleteParams:[this],
									onReverseComplete:this.handleTransitionOutComplete, 
									onReverseCompleteParams:[this]});
	}

	componentDidMount(){
		window.TweenMax.set(this.refs.overlay, {"opacity": 0});
		window.TweenMax.set(this.refs.host, {"opacity": 0, "height": "0%"});
		window.TweenMax.set(this.refs.line1, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line2, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line3, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.line4, {"opacity": 0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.playBtn, {"opacity": 0, "transform":"translateY(1vw)"});


		this.transitionIn.to(this.refs.overlay, .5, {"opacity":1, "delay":.3})
		.to(this.refs.host, .4, {"opacity":1, "height":"100%"}, "-=.3")
		.to(this.refs.line1, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.6")
		.to(this.refs.line2, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.line3, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.line4, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
		.to(this.refs.playBtn, .4, {"opacity":1, "transform":"translateY(0vw)"}, "-=.3")
	}

	handleTransitionComplete(_this){

	}

	handleTransitionOutComplete(_this){

	}

	render(){
		return(
			<div className="bonusInstructions_overlay" ref="overlay">
				<div className="content" ref="content">
					<div className="text">
						<div className="firstLine" ref="line1">HOW TO PLAY BONUS ROUND</div>
						<ul>
							<li ref="line2">GUESS THE TOP ANSWER(S) TO 4 SETS OF QUESTIONS</li>
							<li ref="line3">STUCK? HIT "SKIP" AND COME BACK TO IT LATER</li>
							<li ref="line4">GET THEM ALL CORRECT IN {this.props.timer} SECONDS TO WIN THE GAME!</li>
						</ul>
					</div>
					<div className="host" ref="host"></div>
					<div className="playBtn" ref="playBtn" onClick={() => this.props.initBonusRound()} onMouseOver={() => window.sounds.buttonHover.play()}>PLAY NOW</div>
				</div>
			</div>
		);
	}
}

export default BonusInstructionsOverlay;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/instructions/BonusInstructionsOverlay.js